import axios from "axios";
import { Util, Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

/** 首页新闻列表不带 lang 请求头（与其它 XtAxios 请求区分） */
function withoutLangHeader(config) {
  const cfg = config || {};
  const stripLang = function stripLang(data, headers) {
    if (headers) {
      if (typeof headers.delete === "function") {
        headers.delete("lang");
      } else {
        delete headers.lang;
      }
    }
    return data;
  };
  const prev = cfg.transformRequest;
  const prevArr = prev
    ? Array.isArray(prev)
      ? prev
      : [prev]
    : [];
  const baseArr = (() => {
    const d = axios.defaults.transformRequest;
    if (!d) return [];
    return Array.isArray(d) ? d : [d];
  })();
  return {
    ...cfg,
    transformRequest: [stripLang, ...prevArr, ...baseArr],
  };
}

const URL = getOrigin("www") + "/xt-app/";

//获取首页banner图片
export function getBannerList(config) {
  return XtAxios.get(URL + "public/banner/list", config);
}

/** isNeedLogin 为真时仅已登录用户可见，未登录则从列表中剔除 */
export function filterBannerListByLogin(bannerList, isLogin) {
  if (!Array.isArray(bannerList)) return [];
  return bannerList.filter((item) => {
    if (!item) return false;
    const needLogin =
      item.isNeedLogin === true || Number(item.isNeedLogin) === 1;
    return !needLogin || isLogin;
  });
}

//获取app下载地址
export function getAppVersions(config) {
  return XtAxios.get(URL + "public/app/versions", config);
}
//获取广告列表
export function get_publicAdList(config) {
  return XtAxios.get(URL + `public/ad/list`, config);
}
//广告点击上报
export function get_publicAdClickReport(code, config) {
  return XtAxios.get(URL + `public/ad/click/report/${code}`, config);
}

// 悬浮广告位（广告位 id 目前写死 1000，与 app 一致）
export function getAdvertSpace(config) {
  const spaceId = (config && config.spaceId) || 1000;
  return XtAxios.get(URL + `public/advert-space/${spaceId}`, { ...config, isAutoPopError: false });
}

//推广渠道-监测
export function post_promotionChannelTrace(config) {
  return XtAxios.post(URL + `public/promotion-channel/trace`, null, config);
}

//官方渠道验证
export function get_verifyChannel(config) {
  return XtAxios.get(URL + `public/official-channel-config`, config);
}

//获取热门搜索币种列表
export function get_hotSearchMarket(config) {
  const EXAPI_URL = getOrigin("www") + "/exapi/app/public/";
  return XtAxios.get(EXAPI_URL + `search-market/hot`, config);
}

//获取热门新币币种列表
export function get_newestMarket(config) {
  const EXAPI_URL = getOrigin("www") + "/exapi/app/public/";
  return XtAxios.get(EXAPI_URL + `newest-market?type=1`, config);
}

// 首页新闻列表（GET /public/news/list，language 目前不用传参）
export function getNewsList(config) {
  return XtAxios.get(URL + `public/news/list`, withoutLangHeader(config));
}
